import LanguageDetector from "i18next-browser-languagedetector";
import i18n from "i18next";

import translationEN from "./locales/en";
import translationIT from "./locales/it";
import translationFR from "./locales/fr";
import translationES from "./locales/es";
import translationDE from "./locales/de";

const resources = {
  en: translationEN,
  it: translationIT,
  fr: translationFR,
  es: translationES,
  de: translationDE,
};

i18n.use(LanguageDetector).init({
  resources,
  lng: localStorage.getItem("language")
    ? localStorage.getItem("language")
    : "en",
  load: "languageOnly",
  defaultNS: "translations",
  fallbackLng: "en",
  debug: process.env.NODE_ENV === "development",
  react: {
    wait: true,
    useSuspense: true,
  },
  interpolation: {
    escapeValue: false,
    formatSeparator: ",",
  },
  getAsync: false,
});

export default i18n;
